import { RootState } from "@/store";

export const selectToken = (state: RootState) => state.auth.token;
export const selectUser = (state: RootState) => state.auth.user;
export const selectIsAuthenticated = (state: RootState) =>
  state.auth.isAuthenticated;
export const selectAuthLoading = (state: RootState) => state.auth.loading;
export const selectAuthError = (state: RootState) => state.auth.error;
export const selectIsAdmin = (state: RootState) =>
  state.auth.user?.admin || false;
export const selectUserRoles = (state: RootState) =>
  state.auth.user?.roles || [];
export const selectAuthorizedPortfolios = (state: RootState) =>
  state.auth.user?.authorized_portfolios || null;
export const selectDropcopyIpAddresses = (state: RootState) =>
  state.auth.user?.dropcopy_ip_addresses || null;
export const selectVenueApiKeys = (state: RootState) =>
  state.auth.venueApiKeys || null;
export const selectVenueApiKeysByAccountId = (
  state: RootState,
  accountId: string
) => state.auth.venueApiKeys?.get(accountId) || null;
